import { memo } from 'react';

import { ClockIcon } from 'lucide-react';
import { Trans } from 'react-i18next';

import { EVENT_TEXT } from './eventText';

type Props = { minutes: number };

/**
 * Renders a reminder message with inactivity duration
 */
export const Reminder = memo(({ minutes }: Props) => {
  return (
    <div className="flex items-center justify-center gap-1 px-4 py-2">
      <ClockIcon size={16} className="shrink-0 text-muted-foreground" />
      <span className={EVENT_TEXT}>
        <Trans i18nKey="ai_agents.reminder.human_chat" values={{ 0: minutes }} />
      </span>
    </div>
  );
});

Reminder.displayName = 'Reminder';
